// extracted by mini-css-extract-plugin
module.exports = {"section":"_1aOfmc3E9k0ZKR3HYTtjt8","header":"ejhzAz6NGX3y5z9_dUE5H"};